export default __webpack_public_path__ + "static/anatomy-47101b738d9cc349150dc5eaace38490.png";